import * as React from 'react';
import PropTypes from 'prop-types';

import {
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from '@material-ui/core';

import TaskForm from '../TaskForm';
import { stripHtml } from '../../../htmlUtils';
import { questionContentElementTypes } from '../../../constants';
import HtmlContent from '../../HtmlContent';

const useStyles = makeStyles(theme => ({
    root: {
        background: theme.palette.background.paper,
        padding: theme.spacing(1),
    },
    list: {
        width: '100%',
    },
    question: {
        '&+&': {
            marginTop: theme.spacing(1),
        },
    },
}), { name: 'LinkedResponse' });


const LinkedResponse = ({
    task, element, getProgramItem, getSpecificTaskResponses, contentState,
}) => {
    const classes = useStyles();

    if (!element?.settings) {
        return null;
    }

    const linkedTaskId = element.settings.linkedPageId || element.settings.linkedElementTaskId; // linkedElementTaskId is obsolete (old setting used in emeistring Depresjon)
    const linkedElementId = element.settings.linkedElementId || element.settings.linkedElementElementId; // linkedElementElementId is obsolete (old setting..)

    const refTask = getProgramItem(linkedTaskId);
    if (!refTask) {
        return null;
    }

    let refElement = refTask.contentElements?.find(e => e.id === Number(linkedElementId));
    const refTaskResponses = getSpecificTaskResponses(linkedTaskId);

    if (!refElement) {
        return null;
    }

    if (element.settings.threshold?.length > 0) {
        const threshold = Number(element.settings.threshold);

        refElement = {
            ...refElement,
            questions: refTaskResponses && !Number.isNaN(threshold) ? refElement.questions
                ?.filter(d => refTaskResponses[d.id]?.response?.choiceResponse?.some(r => r.score >= threshold)) : null,
        }
    }

    switch (element.settings.view) {
    case 'list':
        switch (refElement.elementType) {
        case questionContentElementTypes.questionnaire:
            return (
                <div className={classes.root}>
                    <List className={classes.list}>
                        {refElement.questions?.map(d => (
                            <ListItem key={d.id}>
                                <ListItemText primary={stripHtml(d.question)} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            );
        default:
            return (
                <div className={classes.root}>
                    {refElement.questions?.map(d => (
                        <div className={classes.question} key={d.id}>
                            {refElement.questions.length > 1 && <HtmlContent html={d.question} />}
                            <List className={classes.list}>
                                {refTaskResponses?.[d.id]?.response?.choiceResponse?.map(r => (
                                    <ListItem key={r.id}>
                                        <ListItemText primary={r.value} />
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    ))}
                </div>
            );
        }
    case 'default':
    default:
        return (
            <TaskForm
                element={refElement}
                taskResponses={refTaskResponses}
                contentState={contentState}
                onResponse={() => {}}
                getProgramItem={getProgramItem}
                getSpecificTaskResponses={getSpecificTaskResponses}
                taskId={task.id}
                readOnly
            />
        );
    }
}

LinkedResponse.propTypes = {
    element: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
    contentState: PropTypes.string,
};

LinkedResponse.defaultProps = {
    contentState: null,
};

export default LinkedResponse;
